module.exports = __webpack_public_path__ + "static/media/TableTopItemDetailsScreen.67e6e3ba.png";